import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8944 5.10583C15.0866 1.29806 8.9136 1.29806 5.10583 5.10583C1.29806 8.9136 1.29806 15.0866 5.10583 18.8944C8.9136 22.7022 15.0866 22.7022 18.8944 18.8944C22.7022 15.0866 22.7022 8.9136 18.8944 5.10583ZM8.59893 14.6518C8.59906 14.8505 8.67807 15.0411 8.8186 15.1816C8.95914 15.3222 9.14972 15.4012 9.34847 15.4013L13.5911 15.4013C13.6918 15.4049 13.7921 15.3881 13.8861 15.352C13.9802 15.316 14.066 15.2613 14.1385 15.1914C14.2109 15.1214 14.2686 15.0376 14.3079 14.9449C14.3473 14.8522 14.3676 14.7525 14.3676 14.6518C14.3676 14.5511 14.3473 14.4514 14.3079 14.3587C14.2686 14.2659 14.2109 14.1821 14.1385 14.1122C14.066 14.0422 13.9802 13.9876 13.8861 13.9515C13.7921 13.9154 13.6918 13.8987 13.5911 13.9022L11.1587 13.9022L15.1821 9.8788C15.3228 9.73815 15.4018 9.54738 15.4018 9.34847C15.4018 9.14956 15.3228 8.95879 15.1821 8.81814C15.0414 8.67749 14.8507 8.59847 14.6518 8.59847C14.4529 8.59847 14.2621 8.67749 14.1214 8.81814L10.098 12.8416L10.098 10.4091C10.0911 10.2149 10.0092 10.031 9.86936 9.89598C9.72955 9.76102 9.5428 9.68559 9.34847 9.68559C9.15414 9.68559 8.96739 9.76102 8.82758 9.89598C8.68776 10.031 8.60579 10.2149 8.59894 10.4091L8.59893 14.6518Z"
        fill={colorValue}
      />
    </svg>
  );
};
